import platform from 'platform';

export const isServer = () => typeof window === 'undefined';

export const isSafari = () => {
  if (isServer()) return false;

  const { name = '' } = platform;

  const isSafariBrowser = /^safari/i.test(name);

  return isSafariBrowser;
};

export const isAndroid = () => {
  if (isServer()) return false;

  const { os = '' } = platform;

  const isAndroidOS = /^android/i.test(os.toString());

  return isAndroidOS;
};
